export const getGMTFromUTCOffset = (utcOffset: string): string => {
  const offset = parseInt(utcOffset.split(':')[0], 10);
  const formattedOffset = Math.abs(offset).toString().padStart(2, '0');
  const minutes = utcOffset.split(':')[1];
  const sign = offset >= 0 ? '+' : '-';

  return `${sign}${formattedOffset}:${minutes}`;
};
